module.exports = "https://health.dajiuxing.com.cn/img/assets/img/integralIcon.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2Fimg%2FintegralIcon.png
// module id = XIfC
// module chunks = 93